module.exports = [{
      plugin: require('../plugins/indexed-content-plugin/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.18.0-react19.1_gatsby@5.18.0-react19.1_@swc+core@1.15_fddb0c820f39b89b502008205c7a88f8/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TCJBD6M","includeInDevelopment":true,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.18.0-react19.1_@swc+core@1.15.17_@swc+helpers@0.5.19__@swc+helpers@0.5.19_@typ_f8c1856db643c38b5c0698aca5ef64d6/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
